import { Wordmark } from "./primitives";

export function TabletShell({ id, active, children }) {
  const nav = ["Today", "Requests", "Calendar", "Team", "Clients", "Payments"];
  return (
    <div className="still" data-testid={`still-${id}`} style={{ width: 1536, height: 2048, display: "flex" }}>
      <aside style={{ width: 380, padding: "72px 48px", borderRight: "1px solid var(--ink-06)", background: "#fff", display: "flex", flexDirection: "column" }}>
        <Wordmark size={60} />
        <div style={{ marginTop: 6, fontSize: 24, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--burgundy)", fontWeight: 600 }}>business</div>
        <nav style={{ marginTop: 90, display: "flex", flexDirection: "column", gap: 10 }}>
          {nav.map((n) => (
            <div key={n} style={{ padding: "22px 26px", borderRadius: 18, fontSize: 30, fontWeight: n === active ? 600 : 400, background: n === active ? "var(--blush)" : "transparent", color: n === active ? "var(--burgundy)" : "var(--charcoal)", display: "flex", justifyContent: "space-between" }}>
              {n}{n === "Requests" && <span style={{ background: "var(--burgundy)", color: "#fff", borderRadius: 999, fontSize: 24, padding: "2px 16px" }}>1</span>}
            </div>
          ))}
        </nav>
        <div style={{ marginTop: "auto", display: "flex", alignItems: "center", gap: 18 }}>
          <span style={{ width: 64, height: 64, borderRadius: "50%", background: "var(--lilac)" }} />
          <div><div style={{ fontSize: 28, fontWeight: 500 }}>Aura Med Spa</div><div style={{ fontSize: 24, color: "var(--ink-60)" }}>SoHo · Front desk</div></div>
        </div>
      </aside>
      <main style={{ flex: 1, padding: "72px 72px 60px", position: "relative" }}>{children}</main>
    </div>
  );
}

export function Timeline({ slots, from = 5, to = 9, height = 720 }) {
  const hours = [];
  for (let h = from; h <= to; h++) hours.push(h);
  const pxPerMin = height / ((to - from) * 60);
  const y = (h, m) => ((h - from) * 60 + m) * pxPerMin;
  return (
    <div style={{ display: "flex", gap: 24, marginTop: 30 }}>
      <div style={{ width: 90, position: "relative", height }}>
        {hours.map((h) => <div key={h} style={{ position: "absolute", top: y(h, 0) - 14, fontSize: 24, color: "var(--ink-40)" }}>{h}:00</div>)}
      </div>
      {["Maya", "Lena"].map((p) => (
        <div key={p} style={{ flex: 1 }}>
          <div style={{ fontSize: 28, fontWeight: 600, marginBottom: 16 }}>{p}<span style={{ color: "var(--ink-40)", fontWeight: 400, marginLeft: 12 }}>{p === "Maya" ? "Esthetician" : "Brow specialist"}</span></div>
          <div style={{ position: "relative", height, background: "repeating-linear-gradient(to bottom, var(--ink-06) 0 1px, transparent 1px calc(100% / 4))", borderRadius: 12 }}>
            {slots.filter((s) => s.p === p).map((s, i) => (
              <div key={i} style={{ position: "absolute", left: 0, right: 0, top: y(s.h, s.m), height: s.mins * pxPerMin - 4, borderRadius: 14, background: s.bg, color: s.fg, padding: "12px 18px", fontSize: 24, fontWeight: 500, border: s.dashed ? `2px dashed ${s.fg}` : "none", overflow: "hidden" }}>
                {s.label}<div style={{ opacity: .7, fontWeight: 400 }}>{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export const EXISTING = [
  { p: "Maya", h: 5, m: 0, mins: 60, label: "Signature Facial", sub: "5:00 · J. Park", bg: "var(--ink-06)", fg: "var(--ink-60)" },
  { p: "Maya", h: 7, m: 30, mins: 45, label: "Peel", sub: "7:30 · D. Ortiz", bg: "var(--ink-06)", fg: "var(--ink-60)" },
  { p: "Lena", h: 5, m: 30, mins: 30, label: "Lash Tint", sub: "5:30 · A. Wu", bg: "var(--ink-06)", fg: "var(--ink-60)" },
  { p: "Lena", h: 6, m: 30, mins: 40, label: "Brow Lamination", sub: "6:30 · R. Kim", bg: "var(--ink-06)", fg: "var(--ink-60)" },
];
